const WarningIconTriangle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    fill="none"
    viewBox="0 0 36 36"
  >
    <path
      fill="#fff"
      d="M33.598 30.094 18.973 4.78a1.11 1.11 0 0 0-.974-.562c-.38 0-.76.186-.974.562L2.4 30.094a1.125 1.125 0 0 0 .974 1.687h29.25c.865 0 1.406-.935.974-1.687M16.874 14.625c0-.155.127-.281.281-.281h1.688c.154 0 .28.126.28.281v6.469a.28.28 0 0 1-.28.281h-1.688a.28.28 0 0 1-.281-.281zM17.999 27a1.688 1.688 0 0 1 0-3.375 1.688 1.688 0 0 1 0 3.375"
    ></path>
  </svg>
);

export default WarningIconTriangle;
